import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "glitch-target flex mb-3 items-center",
  style: {"font-size":"28px"}
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Pools")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1  invest-farm-separator" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex mb-3 mt-8 items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Top Index Fund Pools")
], -1)
const _hoisted_5 = { class: "mt-8 mb-8 flex" }
const _hoisted_6 = {
  class: "grid grid-cols-2 styled-config-header-invest",
  style: {"width":"100%"}
}
const _hoisted_7 = { class: "col flex items-center" }
const _hoisted_8 = { class: "col flex items-center justify-end" }
const _hoisted_9 = { class: "px-4 lg:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvestFeaturedPoolsCard = _resolveComponent("InvestFeaturedPoolsCard")!
  const _component_BalTabs = _resolveComponent("BalTabs")!
  const _component_TokenSearchInput = _resolveComponent("TokenSearchInput")!
  const _component_ComposePoolTooltip = _resolveComponent("ComposePoolTooltip")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_PoolsTable = _resolveComponent("PoolsTable")!
  const _component_BalAlertUnstaked = _resolveComponent("BalAlertUnstaked")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_InvestFeaturedPoolsCard, {
      pools: _ctx.featuredPools,
      isLoading: _ctx.isLoadingPools || _ctx.embrConfigLoading
    }, null, 8, ["pools", "isLoading"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_BalTabs, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = $event)),
            tabs: _ctx.tabs,
            "no-pad": "",
            class: "-mb-px"
          }, null, 8, ["modelValue", "tabs"]),
          _createVNode(_component_TokenSearchInput, {
            modelValue: _ctx.selectedTokens,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTokens = $event)),
            loading: _ctx.isLoadingPools,
            activeTab: _ctx.activeTab,
            filters: _ctx.embrConfig.poolFilters,
            "active-filters": _ctx.activeFilters,
            onAdd: _ctx.addSelectedToken,
            onRemove: _ctx.removeSelectedToken,
            onToggleFilter: _ctx.toggleFilter,
            class: _normalizeClass(_ctx.bal-_ctx.tab-_ctx.wave-_ctx.not-_ctx.selected)
          }, null, 8, ["modelValue", "loading", "activeTab", "filters", "active-filters", "onAdd", "onRemove", "onToggleFilter", "class"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_ComposePoolTooltip),
          _createVNode(_component_BalBtn, {
            style: {"max-width":"200px"},
            size: "sm",
            class: "hidden lg:block bal-btn",
            label: "Compose a pool",
            onClick: _ctx.goToPoolCreate
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    (_ctx.activeTab === 'wavelength-pools')
      ? (_openBlock(), _createBlock(_component_PoolsTable, {
          key: 0,
          isLoading: _ctx.isLoadingPools,
          data: _ctx.filteredEmbrPools,
          noPoolsLabel: _ctx.$t('noPoolsFound'),
          isPaginated: false,
          isLoadingMore: false,
          onLoadMore: _cache[2] || (_cache[2] = () => {})
        }, null, 8, ["isLoading", "data", "noPoolsLabel"]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'community-pools')
      ? (_openBlock(), _createBlock(_component_PoolsTable, {
          key: 1,
          isLoading: _ctx.isLoadingPools,
          data: _ctx.communityPools,
          noPoolsLabel: _ctx.$t('noPoolsFound'),
          isPaginated: true,
          isLoadingMore: false,
          "sort-externally": true
        }, null, 8, ["isLoading", "data", "noPoolsLabel"]))
      : _createCommentVNode("", true),
    (_ctx.isWalletReady)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.hasUnstakedBpt && _ctx.activeTab === 'my-investments')
              ? (_openBlock(), _createBlock(_component_BalAlertUnstaked, {
                  key: 0,
                  title: "You have unstaked WPT in your wallet",
                  description: "If you deposit your WPT into the farm, you will earn additional rewards paid out in WAVE.",
                  type: "warning",
                  size: "sm",
                  class: ""
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.activeTab === 'my-investments')
            ? (_openBlock(), _createBlock(_component_PoolsTable, {
                key: 0,
                isLoading: _ctx.isLoadingUserPools || _ctx.isLoadingFarms,
                data: _ctx.userPools,
                noPoolsLabel: _ctx.$t('noInvestments'),
                showPoolShares: "",
                selectedTokens: _ctx.selectedTokens,
                class: "mb-8"
              }, null, 8, ["isLoading", "data", "noPoolsLabel", "selectedTokens"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}